module.exports = __webpack_public_path__ + "media/images/facebook-afd08f99328b5f406b4778fb8abc4b3f.png";